import { SET_ROUTE_UNBLOCK } from '@glass/web/modules/app';

const setRouteUnblockAction = () => {
  if (process.env.NODE_ENV !== 'production' && typeof window === 'undefined') {
    throw new Error('setRouteUnblock can only be run in the browser');
  }
  return {
    type: SET_ROUTE_UNBLOCK,
  };
};

export default setRouteUnblockAction;
